import React, { createContext, useContext, useRef, useState } from 'react';

import useSharedStyles from '../theme/pbdqShared.styles';
import PbdqFloatingChatWidget from './PbdqFloatingChatWidget.comp';
import PbdqAgentChatFlow from './PbdqAgentChatFlow.comp';

// Gives every "Talk to the DQ Agent" trigger on a page — the floating
// bottom-right button and any inline link in the page body — access to the
// same DQ Agent popup instance, via context, instead of some of them
// navigating away to /powered-by-dq/chatbot while only the floating button
// opened it in place.
const AgentChatContext = createContext(() => {});

export const useAgentChat = () => useContext(AgentChatContext);

const PbdqAgentChatProvider = ({ children }) => {
    const classes = useSharedStyles();
    const widgetRef = useRef(null);
    const [chatOpen, setChatOpen] = useState(false);
    const openAgentChat = () => widgetRef.current?.open();

    return (
        <AgentChatContext.Provider value={openAgentChat}>
            {children}
            <button
                type="button"
                className={classes.dqFloat}
                style={chatOpen ? { display: 'none' } : undefined}
                onClick={openAgentChat}
            >
                ✦ Talk to the DQ Agent
            </button>
            <PbdqFloatingChatWidget ref={widgetRef} hideToggle onOpenChange={setChatOpen}>
                <PbdqAgentChatFlow />
            </PbdqFloatingChatWidget>
        </AgentChatContext.Provider>
    );
};

export default PbdqAgentChatProvider;
